import { mapState } from 'vuex';
import {CONNECTION_ERROR_MESSAGE, CONNECTION_ERROR_TEXT} from "@/helper/httpService";
import staticPagesDummyData from '@/store/dummyData/staticPages';

/**
 * Generates mixin for given content Paths. Each path is expected to be in the staticPagesContent module in the store.
 * The mixin provides:
 * - for each path a computed property of the same name, mapping to the property in the staticPagesContent module
 * - computed property isInitialized to check if data for all paths is available
 * - start loading data for all paths in created hook
  */
export default function contentLoadingMixin(contentPaths) {
  /*
  TODO: Filtering is not needed as the contentPaths start not null. But after golive the corresponding pages in typo3 can be disabled/hidden.
  const contentPaths = contentPathsAll == null
    ? null 
    : (Array.isArray(contentPathsAll) ? contentPathsAll : [contentPathsAll]).filter(path => ![
        'PRODUKTEPRIVAT',
        'PRODUKTEPRIVATWEITERE',
        'PRODUKTEGEWERBE',
        'PRODUKTEKOMEDEX',
        'PRODUKTEAGROMEX',
        'PRODUKTESERVICE',
        'ARB',
        'ARB_SUS',
        'ARB_YOLIG',
        'PI_STANDARD',
        'PI_EXPERT',
        'PI_PRESTIGE',
        'PI_SUS',
        'PI_YOLIG',
        'HL_STANDARD',
        'HL_EXPERT',
        'HL_PRESTIGE',
        'HL_SUS',
        'HL_YOLIG',
        'NACHWEIS_VORVERSICHERER'
        ].includes(path.toUpperCase()));*/
  return {
    data () {
      return {
        loadingError: false,
        loadingErrorMessage: CONNECTION_ERROR_MESSAGE,
        loadingErrorHint: CONNECTION_ERROR_TEXT
      };
    },
    computed: {
      ...mapState(contentPaths.reduce((previousContent, path) => {
        previousContent[path] = state => state.staticPagesContent[path];
        return previousContent;
      }, {})),
      isInitialized () {
        return contentPaths.every(path => this[path] !== null);
      }
    },
    created() {
      if (!this.isInitialized) {
        this.loadingError = false;
        this.$store.dispatch("populateContent", contentPaths)
          .catch(() => {
            if (this.$store.state.env.environment === 'development') {
              contentPaths.forEach(p => this.$store.commit("updateStaticContent", {
                path: p,
                newContent: staticPagesDummyData[p]
              }));
            } else {
              this.loadingError = true;
            }
          });
      }
    },
  };
}
